// Modal library to display specific page content in an overlay.
// The modal element needs to be set `display: none` beforehand.

export class Modal {
  constructor(selector, opt = {}) {
    this._el = document.querySelector(selector);
    this._withOverlay = opt.overlay === false ? false : true;
  }

  _addOverlay() {
    this._overlayEl = Modal._createOverlayEl();
    this._el.parentNode.insertBefore(this._overlayEl, this._el);
  }

  _removeOverlay() {
    this._el.parentNode.removeChild(this._overlayEl);
    delete this._overlayEl;
  }

  show() {
    this._lastScrollX = window.scrollX;
    this._lastScrollY = window.scrollY;
    Modal._disableBodyScroll();
    if (this._withOverlay) this._addOverlay();
    this._el.classList.add("modal-open");
    this._el.style.display = "unset";
    this._el.scrollTop = 0;
  }

  hide() {
    Modal._enableBodyScroll();
    window.scrollTo(this._lastScrollX, this._lastScrollY);
    if (this._withOverlay) this._removeOverlay();
    this._el.classList.remove("modal-open");
    this._el.style.display = "";
  }

  static _disableBodyScroll() {
    const root = document.documentElement;
    root.style.position = "fixed";
    root.style.width = "100%";
    root.style.height = "100%";
    root.style.overflow = "hidden";
  }

  static _enableBodyScroll() {
    const root = document.documentElement;
    root.style.position = "";
    root.style.width = "";
    root.style.height = "";
    root.style.overflow = "";
  }

  static _createOverlayEl() {
    const el = document.createElement("div");
    el.style.position = "fixed";
    el.style.top = 0;
    el.style.right = 0;
    el.style.bottom = 0;
    el.style.left = 0;
    el.style.backgroundColor = "var(--color-mono-5)";
    el.style.opacity = 0.1;
    return el;
  }
}
